import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="ph-footer">
              <p>&copy; {currentYear} Product Hub IP Pty Ltd. All rights reserved.</p>
    </footer>
  );
};

export default Footer; 